import store from "@/store";
import messages from "../languages/index";
// let language = store.state.language || localStorage.getItem("language") || "pt";

const arrSpecial = store.state.markets.filter(
  (item) => item.id_market === "99913"
);
let nameMArket =
  arrSpecial.length == 0 ? "Especial" : arrSpecial[0].name_market;

const infoSportsMarkets = (sport, language) => {
  const sports = {
    "10": [
      {
        id_market: "99915",
        name_market: "Vencedor BBB23",
        legends: ["Amanda", "Bruna Griphao", "Aline Wirley"],
      },
    ],
    "51": [
      {
        id_market: "99910",
        name_market: "Campeão da Libertadores",
        legends: ["Flamengo", "Atlético PR"],
      },
    ],
    "6046": [
      {
        id_market: "1",
        name_market: messages[language].finalResult,
        legends: ["1", "X", "2"],
      },
      {
        id_market: "2",
        name_market: messages[language].overUnder,
        legends: ["+2.5", "-2.5"],
      },
      {
        id_market: "7",
        name_market: messages[language].doubleChance,
        legends: ["C.X", "X.F.", "C.F"],
      },
      {
        id_market: "13",
        name_market: messages[language].GoalsEuropeanHandicap,
        legends: ["Gm.C", "Gm.F"],
      },
      {
        id_market: "17",
        name_market: messages[language].bothMark,
        legends: ["Amb.", "N.A."],
      },
      {
        id_market: "415",
        name_market: messages[language].oneTwoBoth,
        legends: ["CgFm", "FgCm"],
      },
    ],
    "154919": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Lutador 1", "Lutador 2"],
      },
    ],
    "687890": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Player 1", "Player 2"],
      },
    ],
    "54094": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Tenista 1", "Tenista 2"],
      },
      {
        id_market: "202",
        name_market: messages[language].firstPeriodWinner,
        legends: ["Tenista 1 - 1ºT", "Tenista 2 - 1Tº"],
      },
    ],
    "48242": [
      {
        id_market: "226",
        name_market: messages[language].finalResult,
        legends: ["Equipe 1", "Equipe 2"],
      },
    ],
    "154914": [
      {
        id_market: "226",
        name_market: messages[language].finalResult,
        legends: ["Equipe 1", "Equipe 2"],
      },
      {
        id_market: "28",
        name_market: messages[language].pointsUnderOver,
        legends: ["+8.5", "-8.5"],
      },
    ],
    "154830": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Equipe 1", "Equipe 2"],
      },
    ],
    "131506": [
      {
        id_market: "226",
        name_market: messages[language].finalResult,
        legends: ["Equipe 1", "Equipe 2"],
      },
    ],
    "35709": [
      {
        id_market: "1",
        name_market: messages[language].finalResult,
        legends: ["1", "X", "2"],
      },
    ],
    "265917": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Competidor 1", "Competidor 2"],
      },
    ],
    "621569": [
      {
        id_market: "226",
        name_market: messages[language].finalResult,
        legends: ["Competidor 1", "Competidor 2"],
      },
    ],
    "52": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Time 1", "Time 2"],
      },
    ],
    "53": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Time 1", "Time 2"],
      },
    ],
    "54": [
      {
        id_market: "52",
        name_market: messages[language].finalResult,
        legends: ["Time 1", "Time 2"],
      },
    ],
    "687887": [
      {
        id_market: "1",
        name_market: messages[language].finalResult,
        legends: ["1", "X", "2"],
      },
      {
        id_market: "2",
        name_market: messages[language].overUnder,
        legends: ["+5.5", "-5.5"],
      },
      {
        id_market: "7",
        name_market: messages[language].doubleChance,
        legends: ["C.X", "X.F.", "C.F"],
      },
      {
        id_market: "17",
        name_market: messages[language].bothMark,
        legends: ["Amb.", "N.A."],
      },
    ],
  };
  return sport === "allSports" ? sports : sports[sport];
};

// monta o dropdown e recupera os itens quando um menu é selecionado.
const marketsDropdown = (sport) => {
  let language =
    store.state.language || localStorage.getItem("language") || "en";
  return infoSportsMarkets(sport, language);
  // return infoSportsMarkets[sport];
};

// altera o store a partir do item selecionado no dropdown.
const selectMarketTable = (sport, item, iReplace, type) => {
  const mapTypeToFieldName = {
    nextEvents: "infoSportsMarkets",
    live: "infoSportsMarketsLive",
    bigTable: "bigTableMarkets",
  };

  const fieldName = mapTypeToFieldName[type];
  const markets = store.state[fieldName];

  const _sport = markets[sport];
  _sport.splice(iReplace, 1, item);

  const capitalizedFieldName =
    fieldName.charAt(0).toUpperCase() + fieldName.slice(1);

  store.commit(`set${capitalizedFieldName}`, markets);
};

// armazena as informações no vuex.
const storeInfos = () => {
  let language =
    store.state.language || localStorage.getItem("language") || "en";
  const clone1 = JSON.parse(
    JSON.stringify(infoSportsMarkets("allSports", language))
  ); // clone1 Obj infoSportsMarkets
  const clone2 = JSON.parse(
    JSON.stringify(infoSportsMarkets("allSports", language))
  ); // clone2 Obj infoSportsMarkets
  const clone3 = JSON.parse(
    JSON.stringify(infoSportsMarkets("allSports", language))
  ); // clone2 Obj infoSportsMarkets
  store.commit("setInfoSportsMarkets", clone1);
  store.commit("setInfoSportsMarketsLive", clone2);
  store.commit("setBigTableMarkets", clone3);
};
export { marketsDropdown, selectMarketTable, storeInfos };